import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import Loadable from '../../base/components/Template/Loadable/Loadable'
import { previsualizacionRoutesMap } from './previsualizacionRoutesMap'

const AppPrevisualizacion = Loadable(
  lazy(() => import('./view/listado/Previsualizacion')),
)

const previsualizacionRoutes = [
  {
    path: previsualizacionRoutesMap.previsualizacion.path,
    element: <AppPrevisualizacion />,
    auth: authRoles.admin,
  },
]

export default previsualizacionRoutes
